module.exports = __webpack_public_path__ + "img/img1.53a085e6.png";